import { defineMessages } from 'react-intl';

import { MediaSchema } from './media';

const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Testimonials: {
    id: 'label_testimonials',
    defaultMessage: 'Testimonials',
  },
  Text: {
    id: 'label_text',
    defaultMessage: 'Text',
  },
  Name: {
    id: 'label_first_lastname',
    defaultMessage: 'First and last name',
  },
  Headline: {
    id: 'label_headline',
    defaultMessage: 'Headline',
  },
});

export const TestimonialSchema = (props) => {
  const media = MediaSchema(props);
  return {
    addMessage: props.intl.formatMessage(messages.AddItem),
    fieldsets: [
      {
        fields: ['description', 'name', 'title', 'image', 'focus_point'],
        id: 'default',
        title: '',
      },
    ],
    properties: {
      description: {
        required: true,
        title: props.intl.formatMessage(messages.Text),
        widgetOptions: {
          frontendOptions: {
            widget: 'textarea',
          },
        },
      },
      name: {
        required: true,
        title: props.intl.formatMessage(messages.Name),
        widgetOptions: {
          frontendOptions: {
            widget: 'text',
          },
        },
      },
      title: {
        title: props.intl.formatMessage(messages.Headline),
        widgetOptions: {
          frontendOptions: {
            widget: 'text',
          },
        },
      },
      image: media.properties.image,
      focus_point: media.properties.focus_point,
    },
    required: ['description', 'name'],
    title: props.intl.formatMessage(messages.Testimonials),
  };
};
